import React from 'react'

interface HeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: React.ReactNode
}

export function Header ({ children, ...props }: HeaderProps) {
  return (
    <div
      {...props}
      className='shrink-0 px-6 py-4 border-b border-gray-200'
    >
      {children}
    </div>
  )
}

Header.displayName = 'Modal.Header'
